import { Group, Pagination } from '@mantine/core';
import classes from './PebblePagination.module.scss';
import React from 'react';

interface PebblePaginationProps {
  showControls: boolean;
  totalPagesCount: number;
  activePage: number;
  handlePageChange: (pageNum: number) => void;
}

const PebblePagination: React.FC<PebblePaginationProps> = (props) => {
  const { showControls, totalPagesCount, activePage, handlePageChange } = props;

  return (
    <Group justify="center" className={classes.paginationWrapper}>
      <Pagination
        withControls={showControls}
        total={totalPagesCount}
        value={activePage}
        onChange={handlePageChange}
        boundaries={1}
        classNames={{
          control: classes.paginationButtons,
        }}
        getItemProps={(pageNum: number) => {
          if (pageNum) {
            return { 'aria-label': `${pageNum} item` };
          }
          return {};
        }}
        getControlProps={(control) => {
          switch (control) {
            case 'previous':
              return { 'aria-label': 'previous page button' };
            case 'next':
              return { 'aria-label': 'next page button' };
            case 'first':
              return { 'aria-label': 'first page button' };
            case 'last':
              return { 'aria-label': 'last page button' };
            default:
              return {};
          }
        }}
      />
    </Group>
  );
};

export default PebblePagination;
